import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { isAuthorized } from "@/utils/authToken";

import { baseRoute } from "../../../config/roles";
import { durationToString } from "../../../utils/momentUtils";
import images from "../../../utils/images";
import { Toolbar } from "../../Navigation/Toolbar/Toolbar";

import { AllowAVStep } from "./Steps/AllowAVStep";
import GuidedVideoSection from "./GuidedVideoCallSection";
import { PatientInRoomStep } from "./Steps/PatientInRoomStep";
import { PreviewStep } from "./Steps/PreviewStep";
import ProviderMessageStep from "./Steps/ProviderMessageStep";
import ProviderVideoWorkflow from "./Steps/ProviderVideoWorkflowStep";
import QuestionsStep from "./Steps/QuestionsStep";
import ReconnectStep from "./Steps/ReconnectStep";

import "./styles.scss";

export const GuidedVideoCall = (props) => {
  const {
    allottedTime,
    callDetails,

    endCall,
    localMedia,
    localTracks,
    otherParticipantName,

    participantDisconnected,
    redirectToMessageProviderDialog,
    remoteMedia,

    remoteTracks,
    setStep,
    startCall,
    startTime,
    step,
  } = props;

  let [audioOff, setAudioOff] = useState(false);
  let [videoOff, setVideoOff] = useState(false);
  let [remainingTimeLeft, setRemainingTimeLeft] = useState();
  let [timer, setTimer] = useState("00:00");

  const toggleTrackType = (trackType) => {
    const track = localTracks.find((track) => track.kind === trackType);

    if (track.isEnabled) {
      track.disable();
    } else {
      track.enable();
    }

    if (trackType === "audio") {
      setAudioOff(!track.isEnabled);
    } else {
      setVideoOff(!track.isEnabled);
    }

    //toggleFun(!track.isEnabled)
  };

  let toggleAudioBtn = (
    <button className="GuidedVideoCall__controls-btn">
      <img
        alt="audioToggle"
        className="mx-3 d-block cursor"
        onClick={() => toggleTrackType("audio")}
        src={audioOff ? images("./icons/audio_off.svg") : images("./common/mic.svg")}
      />
    </button>
  );

  let toggleVideoBtn = (
    <button className="GuidedVideoCall__controls-btn">
      <img
        alt="videoToggle"
        className="mx-3 d-block cursor"
        onClick={() => toggleTrackType("video")}
        src={videoOff ? images("./icons/video_off.svg") : images("./common/video.svg")}
      />
    </button>
  );

  useEffect(() => {
    const timerInterval = setInterval(() => {
      let current = moment();

      if (current.isAfter(startTime)) {
        let diff = moment.duration(current.diff(startTime));
        let timeString = durationToString(diff);

        setTimer(timeString);
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  });

  if (isAuthorized("user:patient")) {
    switch (step) {
      case "ALLOW_AV": {
        return <AllowAVStep {...props} />;
      }

      case "PREVIEW": {
        return (
          <PreviewStep
            {...props}
            isPartient={true}
            setAudioOff={setAudioOff}
            setVideoOff={setVideoOff}
            startWorkflow={() => {
              if (!callDetails.patient_question_sets) {
                setStep("QUESTIONS");
              } else {
                startCall();
              }
            }}
            toggleAudioBtn={toggleAudioBtn}
            toggleVideoBtn={toggleVideoBtn}
          />
        );
      }

      case "QUESTIONS": {
        return <QuestionsStep callDetails={callDetails} startCall={startCall} />;
      }

      case "IN_ROOM": {
        return (
          <PatientInRoomStep
            allottedTime={allottedTime}
            localMedia={localMedia}
            otherParticipantName={otherParticipantName}
            participantDisconnected={participantDisconnected}
            redirectToMessageProviderDialog={redirectToMessageProviderDialog}
            remainingTimeLeft={remainingTimeLeft}
            remoteMedia={remoteMedia}
            remoteTracks={remoteTracks}
            timer={timer}
            toggleAudioBtn={toggleAudioBtn}
            toggleVideoBtn={toggleVideoBtn}
            {...props}
          />
        );
      }

      case "PROVIDER_MESSAGE_STEP": {
        return <ProviderMessageStep {...props} />;
      }

      case "RECONNECT":
        return <ReconnectStep {...props} />;
    }
  } else {
    switch (step) {
      case "ALLOW_AV": {
        return <AllowAVStep {...props} />;
      }

      case "PREVIEW": {
        return (
          <PreviewStep
            {...props}
            isPartient={false}
            setAudioOff={setAudioOff}
            setVideoOff={setVideoOff}
            startWorkflow={() => setStep("IN_ROOM")}
            toggleAudioBtn={toggleAudioBtn}
            toggleVideoBtn={toggleVideoBtn}
          />
        );
      }

      case "IN_ROOM": {
        return (
          <ProviderVideoWorkflow
            allottedTime={allottedTime}
            localMedia={localMedia}
            otherParticipantName={otherParticipantName}
            participantDisconnected={participantDisconnected}
            remainingTimeLeft={remainingTimeLeft}
            remoteMedia={remoteMedia}
            remoteTracks={remoteTracks}
            timer={timer}
            toggleAudioBtn={toggleAudioBtn}
            toggleVideoBtn={toggleVideoBtn}
            {...props}
          />
        );
      }
    }
  }
};

const VideoViewBaseComponent = (props) => {
  const { callDetails, content, currentStep, header, workflow } = props;
  const [showLauncher, setShowLauncher] = useState(false);

  const navbarConfiguration = {
    customRenderSection: [
      {
        componentProps: {
          currentStep: currentStep,
          showLauncher: () => setShowLauncher(true),
          workflow: workflow,
          ...props,
        },
        isComponent: true,
        render: GuidedVideoSection,
      },
    ],
  };

  let headerContent = (
    <div className="GuidedVideoCall__header flex-lg-row px-5 tw:static! tw:justify-center">
      {header}
    </div>
  );

  return (
    <>
      <div className="GuidedVideoCall position-fixed">
        <Toolbar baseRoute={baseRoute} navbarConfiguration={navbarConfiguration}></Toolbar>
        {header && headerContent}
        {content}
      </div>
    </>
  );
};

export const VideoViewBase = withRouter(VideoViewBaseComponent);
